import React from 'react'

function BGMusic(){
    return(
        <iframe className='bg-music' title="music"  width="560" height="315" src="https://www.youtuberepeater.com/watch?v=QFo84B17N1I#gsc.tab=0" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
    )
}

export default BGMusic